import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c705c63a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-manage" }
const _hoisted_2 = { class: "left-menu" }
const _hoisted_3 = { class: "left-menu-header" }
const _hoisted_4 = { class: "right-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.application.appName), 1 /* TEXT */),
      _createVNode(_component_el_menu, {
        "default-active": _ctx.defaultPath,
        router: "",
        mode: "vertical",
        class: "el-menu-vertical",
        "text-color": "#ffffff",
        "active-text-color": "#ffffff"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu_item, {
            index: "applicationDetail",
            route: _ctx.applicationPath
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 应用信息 ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["route"]),
          _createVNode(_component_el_menu_item, {
            index: "imuser",
            route: _ctx.imuserPath
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 用户管理 ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["route"]),
          _createVNode(_component_el_menu_item, {
            index: "appConfiguration",
            route: _ctx.appConfigPath
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 应用配置 ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["route"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["default-active"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createBlock(_component_router_view, {
        application: _ctx.application,
        key: _ctx.application
      }, null, 8 /* PROPS */, ["application"]))
    ])
  ]))
}